function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.536 4.59c.202.142.812.566 1.83 1.272 1.018.705 1.798 1.248 2.34 1.629l.379.272c.193.14.354.253.482.34.128.086.283.183.464.29.182.107.353.187.514.24.16.054.31.081.446.081h.018c.137 0 .286-.027.446-.08.161-.054.332-.134.514-.241a9.43 9.43 0 00.464-.29c.128-.087.289-.2.482-.34l.38-.272 4.178-2.902c.435-.303.798-.67 1.09-1.098.291-.428.437-.878.437-1.348 0-.393-.141-.73-.424-1.009a1.38 1.38 0 00-1.005-.42H1.43C.97.714.618.87.37 1.18c-.247.31-.37.696-.37 1.16 0 .375.164.782.491 1.22.327.437.676.78 1.045 1.03z",
  fill: "#D1D1D6"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.107 5.545a185.599 185.599 0 00-4.446 3.08c-.34.25-.615.445-.826.585-.212.14-.493.282-.844.428a2.57 2.57 0 01-.982.219h-.018a2.57 2.57 0 01-.982-.219 5.1 5.1 0 01-.844-.428c-.211-.14-.486-.335-.826-.585-.803-.59-2.282-1.616-4.437-3.08A4.73 4.73 0 010 4.768v7.089c0 .393.14.73.42 1.009.28.28.616.42 1.009.42h13.143c.392 0 .729-.14 1.008-.42.28-.28.42-.616.42-1.01V4.769a4.922 4.922 0 01-.893.777z",
  fill: "#D1D1D6"
});

function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 14",
    fill: "currentColor"
  }, props), _ref, _ref2);
}

export default SvgEmail;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/email.svg
// module id = 1306
// module chunks = 10